document.addEventListener('DOMContentLoaded', function () {

  document.addEventListener('click', async function (event) {

    const button =
      event.target.closest('[data-upsell-add]');

    if (!button) {
      return;
    }

    event.preventDefault();

    if (button.disabled) {
      return;
    }

    const variantId =
      button.dataset.variantId;

    if (!variantId) {
      console.error('Upsell variant ID missing');
      return;
    }


    const addText =
      button.querySelector('.upsell-add-text');

    const loading =
      button.querySelector('.upsell-add-loading');


    button.disabled = true;

    if (addText) {
      addText.hidden = true;
    }

    if (loading) {
      loading.hidden = false;
    }


    try {

      const response = await fetch(
        window.Shopify.routes.root + 'cart/add.js',
        {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },

          body: JSON.stringify({

            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ],

            sections: [
              'cart-drawer',
              'cart-icon-bubble'
            ],

            sections_url:
              window.location.pathname

          })

        }
      );


      const data =
        await response.json();


      if (!response.ok) {

        throw new Error(
          data.description ||
          data.message ||
          'Unable to add product'
        );

      }


      /*
       * Update Cart Drawer
       */

      const cartDrawer =
        document.querySelector('cart-drawer');


      if (cartDrawer) {

        if (
          typeof cartDrawer.renderContents ===
          'function'
        ) {

          cartDrawer.renderContents(data);

        }

        /*
         * Open drawer
         */

        if (
          typeof cartDrawer.open ===
          'function'
        ) {

          cartDrawer.open();

        }

      }


      /*
       * Update cart icon
       */

      if (
        data.sections &&
        data.sections['cart-icon-bubble']
      ) {

        const oldBubble =
          document.querySelector(
            '#cart-icon-bubble'
          );

        if (oldBubble) {

          const temp =
            document.createElement('div');

          temp.innerHTML =
            data.sections[
              'cart-icon-bubble'
            ];

          const newBubble =
            temp.querySelector(
              '#cart-icon-bubble'
            );

          if (newBubble) {

            oldBubble.replaceWith(
              newBubble
            );

          }

        }

      }


      /*
       * Button state
       */

      if (addText) {

        addText.hidden = false;
        addText.textContent = 'Added';

      }

      if (loading) {
        loading.hidden = true;
      }


      /*
       * Reset button after 1.5 seconds
       */

      setTimeout(function () {

        button.disabled = false;

        if (addText) {
          addText.textContent = 'Add';
        }

      }, 1500);


    } catch (error) {

      console.error(
        'Upsell Add to Cart Error:',
        error
      );

      alert(
        error.message ||
        'Something went wrong'
      );


      button.disabled = false;

      if (addText) {
        addText.hidden = false;
      }

      if (loading) {
        loading.hidden = true;
      }

    }

  });

});

